import { BASE_URL } from 'config';
import { useEffect, useState } from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import DataTable from "examples/Tables/DataTable";
import ProductsTableData from "./data/productsTableData";
import TextField from "@mui/material/TextField";
import MDButton from "components/MDButton";
import AddProductModal from "components/AddProductModal";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { CircularProgress, Backdrop, Grid, Box } from "@mui/material";
import RowsPerPageSelector from "components/RowsPerPageSelector";
import ProductCard from './components/product-card';
import Swal from "sweetalert2";
import axios from "axios";

function Products() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(0);
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [currentUser, setCurrentUser] = useState(null); // Add current user state
  const [loading, setLoading] = useState(true);
  const [pageNumber, setPageNumber] = useState(1); // New state for page number
  const [totalPages, setTotalPages] = useState(1); // New state for total pages
  // Modify modal opening logic
  const handleEditClick = (user) => {
    console.log("the user is : ", user);
    setCurrentUser(user);
    setModalOpen(true);
  };
  const handleDeletion = async (user) => {
    // رسالة تأكيد احترافية
    const result = await Swal.fire({
      title: "هل أنت متأكد؟",
      text: `سيتم حذف المنتج "${user.name}" بشكل دائم!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d32f2f",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "نعم، احذف!",
      cancelButtonText: "إلغاء",
      buttonsStyling: true,
      reverseButtons: true,
      focusCancel: true,
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        const token = localStorage.getItem("user-token");
        try {
          const response = await axios.get(
            `${BASE_URL}/administrator/products/delete/${user.id}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          return response.data;
        } catch (error) {
          Swal.showValidationMessage(
            `فشل الحذف: ${error.response?.data?.message || error.message}`
          );
          return false;
        }
      },
    });

    // معالجة النتيجة
    if (result.isConfirmed) {
      if (result.value?.status) {
        Swal.fire({
          icon: "success",
          title: "تم الحذف!",
          text: "تم حذف المنتج بنجاح",
        });
        fetchUsers();
      } else {
        Swal.fire({
          title: "فشل الحذف!",
          text: result.value?.message || "حدث خطأ غير متوقع",
          icon: "error",
        });
      }
    }
  };
  const handleActivation = async (user) => {
    try {
      const token = localStorage.getItem("user-token");
      const response = await axios.get(
        `${BASE_URL}/administrator/products/active/${user.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log(response);
      if (response.data.status) {
        Swal.fire({
          icon: "success",
          title: "تم التحديث!",
          text: "تم تغيير حالة المنتج بنجاح",
        });
        // قم بتحديث الحالة المحلية إذا لزم الأمر
        fetchUsers(pageNumber); // إعادة جلب البيانات من السيرفر
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "فشل التحديث!",
        text: error.response?.data?.message || "حدث خطأ أثناء التحديث",
      });
    }
  };




  useEffect(() => {
    fetchUsers(pageNumber);
  }, [pageNumber]);
  // get all products with pagination , with search
  const fetchUsers = async (page) => {
    setLoading(true);
    const token = localStorage.getItem("user-token");
    try {
      const response = await fetch(
        `${BASE_URL}/administrator/products?page=${page}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await response.json();
      setUsers(data.data || []);
      console.log("users", users)
      setRowsPerPage(data.per_page || 10);
      setTotalPages(data.last_page || 1); // Update total pages
      console.log(data.data);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
    setLoading(false);
  };






  const { columns, rows } = ProductsTableData(users, handleEditClick, fetchUsers);

  const filteredRows = rows.filter((row) =>
    row.name.props.name.toLowerCase().includes(search.toLowerCase())
  );
  const paginatedRows = filteredRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  console.log("paginatedRows", paginatedRows)
  useEffect(() => {
    setPage(0); // تصفير الصفحة عند تغيير البحث أو عدد الصفوف
  }, [search, rowsPerPage]);
  return (
    <>
      <Backdrop open={loading} sx={{ zIndex: 2000, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <AddProductModal
        open={modalOpen}
        onClose={() => {
          setModalOpen(false);
          setCurrentUser(null);
        }}
        onUserAdded={fetchUsers}
        initialData={currentUser} // Pass current user data
      />

      <MDBox pt={6} pb={3}>
        <Card sx={{ height: "100%", pb: 2 }}>
          <MDBox
            mx={2}
            mt={-3}
            py={3}
            px={2}
            borderRadius="lg"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              background: "linear-gradient(90deg, #ca9937, #e0b15a)",
              boxShadow: 3,
            }}
          >
            <MDTypography variant="h6" color="white">
              قائمة المنتجات
            </MDTypography>

            <MDButton
              variant="contained"
              color="white"
              startIcon={<AddIcon />}
              sx={{ color: "white" }}
              onClick={() => setModalOpen(true)}
            >
              منتج جديد
            </MDButton>
          </MDBox>

          <MDBox pt={3} px={2}>
            <Box display="flex" gap={2} >

              <TextField
                fullWidth
                label="بحث بالاسم "
                variant="outlined"
                size="small"

                onChange={(e) => setSearch(e.target.value)}
              />

              <RowsPerPageSelector value={rowsPerPage} onChange={setRowsPerPage} />

            </Box>
            {/* <DataTable
              table={{ columns, rows: paginatedRows }}
              isSorted={false}
              entriesPerPage={false}
              showTotalEntries={true}
              noEndBorder
              sx={{
                "& .MuiTable-root": { minWidth: 1000 },
                "& .MuiTableCell-root": {
                  py: 1.5,
                  borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
                },
                "& .MuiTableHead-root": {
                  backgroundColor: (theme) => theme.palette.grey[100],
                },
              }}
            /> */}
          </MDBox>

        </Card>
      </MDBox>
      <Grid container spacing={2}>
        {
          users.map((user) => (
            <Grid item size={{ xs: 12, sm: 6, md: 3, }} key={user.id}>
              <ProductCard product={user} handleDeletion={handleDeletion} handleActivation={handleActivation} handleEditClick={handleEditClick} />
            </Grid>
          ))
        }
      </Grid>
      <MDBox display="flex" justifyContent="center" mt={4} pb={4} px={2}>
        <MDButton
          // onClick={() => setPage((prev) => Math.max(prev - 1, 0))}
          onClick={() => {
            if (pageNumber > 1) {
              setPageNumber(pageNumber - 1);
            }
          }} // Update to use pageNumber state
          disabled={pageNumber === 1}
          sx={{
            background: "linear-gradient(90deg, #ca9937, #e0b15a)",
            color: "text.main",
            borderRadius: "50%",
            width: "50px",
            height: "50px",
            minWidth: "50px",
            mx: 1,
            "&:hover": {
              background: "linear-gradient(90deg, #b6842f, #d39d45)",
            },
          }}
        >
          <ArrowForwardIcon />
        </MDButton>

        <MDTypography
          variant="button"
          color="text"
          sx={{
            display: "flex",
            alignItems: "center",
            mx: 3,
            fontWeight: "bold",
          }}
        >
          {pageNumber}
        </MDTypography>

        <MDButton
          /* onClick={() =>
            setPage((prev) =>
              (prev + 1) * rowsPerPage >= filteredRows.length ? prev : prev + 1
            )
          } */
          onClick={() => {
            if (pageNumber < totalPages) {
              setPageNumber(pageNumber + 1);
            }
          }} // Update to use pageNumber and totalPages states
          disabled={pageNumber >= totalPages}
          sx={{
            background: "linear-gradient(90deg, #ca9937, #e0b15a)",
            color: "text.main",
            borderRadius: "50%",
            width: "50px",
            height: "50px",
            minWidth: "50px",
            mx: 1,
            "&:hover": {
              background: "linear-gradient(90deg, #b6842f, #d39d45)",
            },
          }}
        >
          <ArrowBackIcon />
        </MDButton>
      </MDBox>
    </>
  );
}

export default Products;
